import React, { useState } from 'react';
import { products } from '../mockData';
import { ShoppingBag } from 'lucide-react';

const Vibe = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = ['All', 'Shirts', 'Hoodies', 'Shorts', 'Pants', 'Gloves'];

  const filteredProducts = selectedCategory === 'All'
    ? products
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="bg-[#1a1c1b] min-h-screen pt-24 pb-20">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-[#d9fb06] font-black text-5xl md:text-7xl uppercase mb-4">
            The Vibe
          </h1>
          <p className="text-[#dfddd6] text-xl max-w-3xl mx-auto">
            Gear up with premium NexGen MMA merchandise. Quality training gear for serious fighters.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full font-semibold uppercase text-sm transition-all ${
                selectedCategory === category
                  ? 'bg-[#d9fb06] text-[#1a1c1b]'
                  : 'bg-[#302f2c] text-[#888680] hover:bg-[#3f4816] hover:text-[#d9fb06]'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProducts.map((product) => (
            <div
              key={product.id}
              className="bg-[#302f2c] border border-[#3f4816] overflow-hidden hover:border-[#d9fb06] transition-all duration-300 group"
            >
              <div className="aspect-square overflow-hidden bg-[#1a1c1b]">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[#888680] text-xs uppercase tracking-wide">
                    {product.category}
                  </span>
                  <span className="text-[#d9fb06] font-bold text-xl">
                    {product.price}
                  </span>
                </div>
                <h3 className="text-[#dfddd6] font-bold text-xl mb-3">
                  {product.name}
                </h3>
                <div className="mb-4">
                  <p className="text-[#888680] text-sm mb-2">Available Sizes:</p>
                  <div className="flex flex-wrap gap-2">
                    {product.sizes.map((size) => (
                      <span
                        key={size}
                        className="bg-[#1a1c1b] text-[#dfddd6] px-3 py-1 text-xs font-semibold rounded"
                      >
                        {size}
                      </span>
                    ))}
                  </div>
                </div>
                <button className="w-full bg-[#d9fb06] text-[#1a1c1b] px-6 py-3 rounded-full font-bold uppercase text-sm hover:opacity-90 transition-all hover:scale-105 flex items-center justify-center">
                  <ShoppingBag size={18} className="mr-2" />
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Info Banner */}
        <div className="mt-12 bg-[#3f4816] p-8 rounded-lg text-center">
          <h3 className="text-[#d9fb06] font-black text-2xl uppercase mb-3">
            Visit Our Store
          </h3>
          <p className="text-[#dfddd6] mb-4 max-w-2xl mx-auto">
            All merchandise available for purchase at our Dojo. Contact us for bulk orders or custom designs.
          </p>
          <a
            href="/book"
            className="bg-[#d9fb06] text-[#1a1c1b] px-8 py-3 rounded-full font-bold uppercase text-sm hover:opacity-90 transition-all inline-flex items-center justify-center"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default Vibe;
